var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.116 4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.8,12.5l-.853,33.254H34.835L32.277,25.29,29.719,45.754H24.6L23.75,12.5Z",
    transform: "translate(3.536 0.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.813,14.375H40.7",
    transform: "translate(3.558 0.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30,12.5v7.674",
    transform: "translate(5.812 0.29)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 3.155,
    y2: 3.496,
    transform: "translate(40.928 17.906)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.155,
    y2: 3.496,
    transform: "translate(27.541 17.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.049,4.375l5.116,2.132S24.607,14.1,24.607,17.165V34.219H14.375",
    transform: "translate(0.12 -2.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.75,5.938s1.705,1.62,1.705,6.4",
    transform: "translate(3.536 -2.1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    transform: "translate(14.069 19.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.167,22.14l7.248-7.93L21.71,11.652l2.558-1.705L23.415,4.83,20.857,3.125H10.625",
    transform: "translate(-1.246 -3.125)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.116,
    y2: 17.565,
    transform: "translate(14.495)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.969,
    transform: "translate(18.759 24.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.116,4.375,5,6.507S7.558,14.1,7.558,17.165V34.219H17.79",
    transform: "translate(-3.295 -2.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.455,5.938s-1.705,1.62-1.705,6.4V31.944H8.013",
    transform: "translate(-3.75 -2.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.536,3.125,17.5,23.589,8.978,14.21l1.705-2.558L8.125,9.946,8.978,4.83l2.558-1.705H21.768",
    transform: "translate(-2.156 -3.125)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 5.969,
    transform: "translate(4.263 24.728)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 11.085,
    transform: "translate(15.348 20.464)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 55.067,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuit);
export default __webpack_public_path__ + "static/media/Suit.0f253f9d88092f3a864fe5bec7cb0fbb.svg";
export { ForwardRef as ReactComponent };